import Header from './components/Header';
import Hero from './components/Hero';
import TopicsSection from './components/TopicsSection';
import CardsSection from './components/CardsSection';
import FaqSection from './components/FaqSection';
import AboutSection from './components/AboutSection';
import IndexSection from './components/IndexSection';
import ContactSection from './components/ContactSection';
import UpdatesSection from './components/UpdatesSection';
import RankingSection from './components/RankingSection';
import CarouselSection from './components/CarouselSection';
import MediaSection from './components/MediaSection';
import AppSection from './components/AppSection';
import CommentsSection from './components/CommentsSection';
import FeaturesSection from './components/FeaturesSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <TopicsSection />
        <CardsSection />
        <FaqSection />
        <AboutSection />
        <IndexSection />
        <ContactSection />
        <UpdatesSection />
        <RankingSection />
        <CarouselSection />
        <MediaSection />
        <AppSection />
        <CommentsSection />
        <FeaturesSection />
      </main>
      <Footer />
    </>
  );
}